import { render } from "./FR.APL.02.vue?vue&type=template&id=4a22f138&ts=true"
import script from "./FR.APL.02.vue?vue&type=script&lang=ts"
export * from "./FR.APL.02.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/inputs/form/SchemaByFormCode/FR.APL.02.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a22f138"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a22f138', __exports__)) {
    api.reload('4a22f138', __exports__)
  }
  
  module.hot.accept("./FR.APL.02.vue?vue&type=template&id=4a22f138&ts=true", () => {
    api.rerender('4a22f138', render)
  })

}


export default __exports__